import { cx } from '@twind/core';
import { useLanguages } from 'app/hooks/useOstroModules';
import { Outlet } from 'react-router-dom';
import { useTailorHalfOpen } from 'app/hooks/useTailorHalfOpen';
import { useContactFormState } from 'app/modules/contact-form/stores/useContactFormState';

import ContactForm from '../../modules/contact-form/ContactForm';
import TailorImportantInformation from '../../modules/tailor/components/TailorImportantInformation';
import ScreenAnimation from '../ScreenAnimation';

export function RootLayout({
  hideImportantInformation = false,
  stickyImportantInformation = false,
  hideContactForm = false,
}: {
  hideImportantInformation?: boolean;
  stickyImportantInformation?: boolean;
  hideContactForm?: boolean;
}) {
  const { isOpen } = useContactFormState();
  const { halfOpen } = useTailorHalfOpen();

  useLanguages();

  return (
    <ScreenAnimation>
      {!hideImportantInformation && !halfOpen && (
        <TailorImportantInformation className={cx('shrink-0', stickyImportantInformation ? 'sticky top-0' : '')} />
      )}
      <Outlet />
      {!hideContactForm && isOpen && <ContactForm />}
    </ScreenAnimation>
  );
}
